document.addEventListener("DOMContentLoaded", () => {
  const firstSlide = document.querySelector(
    '.ep__beauty-offers-slide[data-index="1"]'
  );
  const secondSlide = document.querySelector(
    '.ep__beauty-offers-slide[data-index="2"]'
  );

  const firstButton = firstSlide.querySelector(
    ".ep__beauty-offers-slide-controlls > svg:nth-of-type(2)"
  );
  const secondButton = secondSlide.querySelector(
    ".ep__beauty-offers-slide-controlls > svg:nth-of-type(1)"
  );

  const firstButtonMobile = document.querySelector(
    ".ep__beauty-offers-slide-controlls > svg:nth-of-type(2)"
  );
  const secondButtonMobile = document.querySelector(
    ".ep__beauty-offers-slide-controlls > svg:nth-of-type(1)"
  );
  const currentPageNumber = document.querySelector(
    ".ep__beauty-offers-control-number"
  );
  const beautyOffers_loadingBar = document.querySelector(
    ".ep__beauty-offers-slide-loading-bar-inside[data-index='2']"
  );
  secondButton.addEventListener("click", (event) => {
    // HIDE THE SECOND SLIDE
    secondSlide.classList.add("hidden");
    currentPageNumber.textContent = 1;
    beautyOffers_loadingBar.style.width = "50%";
  });
  firstButton.addEventListener("click", (event) => {
    // SHOW THE SECOND SLIDE
    secondSlide.classList.remove("hidden");
    currentPageNumber.textContent = 2;
    beautyOffers_loadingBar.style.width = "100%";
  });
  secondButtonMobile.addEventListener("click", (event) => {
    // HIDE THE SECOND SLIDE
    secondSlide.classList.add("hidden");
    currentPageNumber.textContent = 1;
    beautyOffers_loadingBar.style.width = "50%";
  });
  firstButtonMobile.addEventListener("click", (event) => {
    // SHOW THE SECOND SLIDE
    secondSlide.classList.remove("hidden");
    currentPageNumber.textContent = 2;
    beautyOffers_loadingBar.style.width = "100%";
  });
  const slider = document.querySelector(".ep__beauty-offers"); // parent of the slides
  let startX = 0,
    startY = 0;

  const showSecond = () => {
    secondSlide.classList.remove("hidden");
    currentPageNumber.textContent = 2;
    beautyOffers_loadingBar.style.width = "100%";
  };
  const showFirst = () => {
    secondSlide.classList.add("hidden");
    currentPageNumber.textContent = 1;
    beautyOffers_loadingBar.style.width = "50%";
  };

  slider?.addEventListener(
    "touchstart",
    (e) => {
      const t = e.touches[0];
      startX = t.clientX;
      startY = t.clientY;
    },
    { passive: true }
  );

  slider?.addEventListener(
    "touchend",
    (e) => {
      const t = e.changedTouches[0];
      const dx = t.clientX - startX;
      const dy = t.clientY - startY;

      // horizontal swipe with a small threshold
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
        if (dx < 0) {
          // swipe left → next
          showSecond();
        } else {
          // swipe right → prev
          showFirst();
        }
      }
    },
    { passive: true }
  );
});
